import { lazy } from "react";

// Screens load on first visit, so the form, validation and QR code libraries
// stay out of the first download. AppShell's Suspense shows them loading; a
// chunk that fails to load (for example after a deploy) reaches
// RouteErrorScreen. The access gates stay eager, so a screen's code is only
// fetched for someone it is drawn for.
export const AccountScreen = lazy(() => import("../screens/AccountScreen").then((m) => ({ default: m.AccountScreen })));
export const AssistedRecoveryScreen = lazy(() =>
  import("../screens/AssistedRecoveryScreen").then((m) => ({ default: m.AssistedRecoveryScreen })),
);
export const AuthenticatorReplacementScreen = lazy(() =>
  import("../screens/AuthenticatorReplacementScreen").then((m) => ({ default: m.AuthenticatorReplacementScreen })),
);
export const CashiersScreen = lazy(() => import("../screens/CashiersScreen").then((m) => ({ default: m.CashiersScreen })));
export const DevicesScreen = lazy(() => import("../screens/DevicesScreen").then((m) => ({ default: m.DevicesScreen })));
export const InvitationAcceptScreen = lazy(() =>
  import("../screens/InvitationAcceptScreen").then((m) => ({ default: m.InvitationAcceptScreen })),
);
export const OverviewScreen = lazy(() => import("../screens/OverviewScreen").then((m) => ({ default: m.OverviewScreen })));
export const ReportsScreen = lazy(() => import("../screens/ReportsScreen").then((m) => ({ default: m.ReportsScreen })));
export const ShiftsScreen = lazy(() => import("../screens/ShiftsScreen").then((m) => ({ default: m.ShiftsScreen })));
export const ZReportScreen = lazy(() => import("../screens/ZReportScreen").then((m) => ({ default: m.ZReportScreen })));
export const PasswordResetScreen = lazy(() => import("../screens/PasswordResetScreen").then((m) => ({ default: m.PasswordResetScreen })));
export const StaffScreen = lazy(() => import("../screens/StaffScreen").then((m) => ({ default: m.StaffScreen })));
export const SupportAccessScreen = lazy(() =>
  import("../screens/SupportAccessScreen").then((m) => ({ default: m.SupportAccessScreen })),
);
export const SupportWorkScreen = lazy(() => import("../screens/SupportWorkScreen").then((m) => ({ default: m.SupportWorkScreen })));
export const CatalogueScreen = lazy(() => import("../screens/CatalogueScreen").then((m) => ({ default: m.CatalogueScreen })));
export const StockScreen = lazy(() => import("../screens/StockScreen").then((m) => ({ default: m.StockScreen })));
export const TillHealthScreen = lazy(() => import("../screens/TillHealthScreen").then((m) => ({ default: m.TillHealthScreen })));
export const TenantsScreen = lazy(() => import("../screens/TenantsScreen").then((m) => ({ default: m.TenantsScreen })));
export const ShopSettingsScreen = lazy(() => import("../screens/ShopSettingsScreen").then((m) => ({ default: m.ShopSettingsScreen })));
export const BrandingSettingsScreen = lazy(() =>
  import("../screens/BrandingSettingsScreen").then((m) => ({ default: m.BrandingSettingsScreen })),
);
export const BusinessSettingsScreen = lazy(() =>
  import("../screens/BusinessSettingsScreen").then((m) => ({ default: m.BusinessSettingsScreen })),
);
export const LegalAcceptanceScreen = lazy(() =>
  import("../screens/LegalAcceptanceScreen").then((m) => ({ default: m.LegalAcceptanceScreen })),
);
export const LegalDocumentScreen = lazy(() =>
  import("../screens/LegalDocumentScreen").then((m) => ({ default: m.LegalDocumentScreen })),
);
